export class MenuConstants {
  constructor() {}

  static readonly Status = "/status";
  static readonly Todos = "/todos";
  static readonly OutstandingMonitor = "/painel-pendencia-atuacao";
  static readonly MonitorRecebiveis = "/monitor-recebiveis";
  static readonly MonitorArquivos = "/monitor-arquivos";
  static readonly UploadsPesc = "/uploads/pesc";
  static readonly UploadsTicket = "/uploads/ticket";
  static readonly UploadsCarga = "/uploads/carga";
  static readonly ObterCargas = "/obter-cargas";
  static readonly Usuarios = "/usuarios";
  static readonly Grupos = "/grupos";
  static readonly Cutoff = "/cutoff";
  static readonly Calendario = "/calendario";
  static readonly Counterpart = "/counterpart";
  static readonly Wallet = "/wallet";

  static readonly Tickets = {
    PrivateFixedIncome: "/cetip",
    Futures: "/futures",
    Contracted: "/contracted",
    Quota: "/quota",
    Margin: "/margin",
    VariableIncome: "/rv",
    PublicFixedIncome: "/selic",
    SwapCetip: "/swap-cetip",
    CurrencyTerm: "/currency-term",
    Transfer: "/transfer",
    Exchange: "/exchange",
    Loan: "/loan",
    Expenses: "/expenses",
    Liabilities: "/liabilities",
    StructuredOperationOrder: "/structured-order",
    StructuredOperations: "/structured",
  };
}
